<template>
  <div class="comunityPage">
    <SubSectionBanner :subSectionData="subSectionData" />
    <section id="noticias" class="secciones seccion-blanca text-center">
      <div class="container">
        <template v-if="detail_open">
          <!-- Contenido de la Página -->
          <section id="contenido-general" class="secciones seccion-blanca">
            <div class="container">
              <div class="col-12 sin-padding">
                <button
                  @click="closeSignedDetail()"
                  class="btn-3d btn-3d-sm btn-3d-celeste ico-atras"
                >
                  {{ lenguage == 1 ? 'Atrás' : 'Back' }}
                </button>
                <div class="botones-compartir">
                  <span>{{ lenguage == 1 ? 'Compartir' : 'Share' }}:</span>
                  <a
                    href="javascript: void(0);"
                    :onclick="boton_fb"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Compartir en Facebook"
                    class="btn-compartir btn-fb"
                    ><i class="fa fa-facebook"></i
                  ></a>
                  <a
                    v-bind:href="boton_tw"
                    onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');return false;"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Compartir en Twitter"
                    class="btn-compartir btn-tt"
                    ><i class="fa fa-twitter"></i
                  ></a>
                  <a
                    v-bind:href="boton_ld"
                    onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=700,width=600');return false;"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Compartir en LinkedIn"
                    class="btn-compartir btn-li"
                    ><i class="fa fa-linkedin"></i
                  ></a>
                </div>
              </div>
              <div class="col-12 sin-padding">
                <div class="noticia-fecha" v-if="lenguage == 1">
                  {{ detail_item.date_new | esDate }}
                </div>
                <div class="noticia-fecha" v-else>{{ detail_item.date_new | enDate }}</div>

                <div class="noticia-titulo">
                  <h1>
                    {{ lenguage == 1 ? detail_item.title_news_es : detail_item.title_news_en }}
                  </h1>
                </div>
                <div class="noticia-galeria">
                  <!--  Galería de fotos  -->
                  <template
                    v-if="
                      detail_item.url_2nd_image == 'products/empty-img' &&
                        detail_item.url_3rd_image == 'products/empty-img' &&
                        detail_item.url_4th_image == 'products/empty-img'
                    "
                  >
                    <div class="carrusel-noticia" style="">
                      <img
                        v-bind:src="imgPreUrl + detail_item.url_main_image + 'x640.jpg'"
                        alt=""
                        class="imagen-cover"
                      />
                    </div>
                  </template>
                  <template v-else>
                    <div class="carrusel-noticia owl-carousel owl-theme" data-slideout-ignore>
                      <div class="item">
                        <img
                          v-bind:src="imgPreUrl + detail_item.url_main_image + 'x640.jpg'"
                          alt=""
                          class="imagen-cover"
                        />
                      </div>

                      <template
                        v-if="
                          detail_item.url_2nd_image != '' &&
                            detail_item.url_2nd_image != 'products/empty-img'
                        "
                      >
                        <div class="item">
                          <img
                            v-bind:src="imgPreUrl + detail_item.url_2nd_image + 'x640.jpg'"
                            alt=""
                            class="imagen-cover"
                          />
                        </div>
                      </template>

                      <template
                        v-if="
                          detail_item.url_3rd_image != '' &&
                            detail_item.url_3rd_image != 'products/empty-img'
                        "
                      >
                        <div class="item">
                          <img
                            v-bind:src="imgPreUrl + detail_item.url_3rd_image + 'x640.jpg'"
                            alt=""
                            class="imagen-cover"
                          />
                        </div>
                      </template>

                      <template
                        v-if="
                          detail_item.url_4th_image != '' &&
                            detail_item.url_4th_image != 'products/empty-img'
                        "
                      >
                        <div class="item">
                          <img
                            v-bind:src="imgPreUrl + detail_item.url_4th_image + 'x640.jpg'"
                            alt=""
                            class="imagen-cover"
                          />
                        </div>
                      </template>
                    </div>
                    <script language="javascript" type="application/javascript">
                      $(document).ready(function() {
                        var owl = $('.carrusel-noticia');
                        owl.owlCarousel({
                          margin: 0,
                          nav: true,
                          loop: true,
                          autoplay: true,
                          autoplayTimeout: 6000,
                          autoplayHoverPause: false,
                          items: 1,
                        });
                      });
                    </script>
                  </template>
                </div>
                <div class="noticia-cuerpo">
                  <p>
                    <span
                      v-html="lenguage == 1 ? detail_item.desc_news_es : detail_item.desc_news_en"
                    ></span>
                  </p>
                </div>
              </div>
              <div class="col-12 sin-padding">
                <button
                  @click="closeSignedDetail()"
                  class="btn-3d btn-3d-sm btn-3d-celeste ico-atras"
                >
                  {{ lenguage == 1 ? 'Atrás' : 'Back' }}
                </button>
                <div class="botones-compartir">
                  <span>{{ lenguage == 1 ? 'Compartir' : 'Share' }}:</span>
                  <a
                    href="javascript: void(0);"
                    :onclick="boton_fb"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Compartir en Facebook"
                    class="btn-compartir btn-fb"
                    ><i class="fa fa-facebook"></i
                  ></a>
                  <a
                    v-bind:href="boton_tw"
                    onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');return false;"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Compartir en Twitter"
                    class="btn-compartir btn-tt"
                    ><i class="fa fa-twitter"></i
                  ></a>
                  <a
                    v-bind:href="boton_ld"
                    onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=700,width=600');return false;"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Compartir en LinkedIn"
                    class="btn-compartir btn-li"
                    ><i class="fa fa-linkedin"></i
                  ></a>
                </div>
              </div>
            </div>
          </section>
        </template>
        <template v-else>
          <template v-if="item_list.length != 0 || main_item != ''">
            <SubSectionStandartHead :subSectionData="subSectionData" />
            <section
              id="noticias"
              class="secciones seccion-blanca text-center"
              style="padding-top: 0px;"
            >
              <div class="container-fluid noticias-principal">
                <div class="noticias rounded-shadow">
                  <a
                    @click="openSignedDetail(main_item, false)"
                    class="noticias-foto rounded-shadow-image"
                  >
                    <img
                      v-bind:src="imgPreUrl + main_item.url_main_image + 'x640.jpg'"
                      v-bind:alt="main_item.title_news_es"
                      class="imagen-cover"
                    />
                  </a>
                  <a @click="openSignedDetail(main_item, false)" class="noticias-contenido">
                    <div class="noticias-fecha" v-if="lenguage == 1">
                      <strong>{{ main_item.date_new | esDate }}</strong>
                    </div>
                    <div class="noticias-fecha" v-else>
                      <strong>{{ main_item.date_new | enDate }}</strong>
                    </div>
                    <br />
                    <p>
                      <i class="fa fa-star" style="color: #d3bc39;font-size: 20px;"></i
                      ><strong> Entrada Destacada</strong>
                    </p>
                    <br />

                    <div class="noticias-titulo">
                      <h2>
                        <strong>{{
                          lenguage == 1 ? main_item.title_news_es : main_item.title_news_en
                        }}</strong>
                      </h2>
                    </div>
                    <small>Por: Armaq</small>
                    <div class="noticias-texto">
                      <p>
                        {{
                          lenguage == 1
                            ? main_item.desc_news_es.substring(0, 170) + '...'
                            : (main_item.desc_news_en.substring(0, 170) + '...') | striphtml
                        }}
                      </p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="container-fluid sin-padding seccion-blanca">
                <div class="container sin-padding">
                  <div class="row noticias-grupo">
                    <div class="col-sm-12" v-for="(item, index) in item_list" :key="index">
                      <div class="noticias rounded-shadow">
                        <a
                          @click="openSignedDetail(item, false)"
                          class="noticias-foto rounded-shadow-image"
                        >
                          <img
                            v-bind:src="imgPreUrl + item.url_main_image + 'x320.jpg'"
                            v-bind:alt="item.title_news_es"
                            class="imagen-cover"
                          />
                        </a>
                        <a @click="openSignedDetail(item, false)" class="noticias-contenido">
                          <div class="noticias-fecha" v-if="lenguage == 1">
                            <strong>{{ item.date_new | esDate }}</strong>
                          </div>
                          <div class="noticias-fecha" v-else>
                            <strong>{{ item.date_new | enDate }}</strong>
                          </div>

                          <div class="noticias-titulo">
                            <h2>
                              <strong>{{
                                lenguage == 1 ? item.title_news_es : item.title_news_en
                              }}</strong>
                            </h2>
                          </div>

                          <div class="noticias-texto">
                            <small>Por: Armaq</small>
                            <p>
                              {{
                                lenguage == 1
                                  ? item.desc_news_es.substring(0, 150) + '...'
                                  : (item.desc_news_en.substring(0, 150) + '...') | striphtml
                              }}
                            </p>
                          </div>
                        </a>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="paginador text-center">
                        <ul>
                          <template v-if="current_page > 1">
                            <li>
                              <button
                                class="btn page-item"
                                @click="listadoPagina(current_page - 1)"
                              >
                                <span> <i class="fa fa-arrowleft"></i> </span>
                              </button>
                            </li>
                          </template>
                          <template v-else>
                            <li>
                              <button class="btn page-item pag-desactivado">
                                <span> <i class="fa fa-arrow-left"></i> </span>
                              </button>
                            </li>
                          </template>
                          <li v-for="page in pages" :key="page">
                            <button
                              :class="['btn page-item', page === current_page ? 'active' : '']"
                              @click="page == 1 ? obtener_items_paginado() : listadoPagina(page)"
                            >
                              {{ page }}
                            </button>
                          </li>
                          <template v-if="current_page == final_page">
                            <li>
                              <button class="btn page-item pag-desactivado">
                                <span><i class="fa fa-arrow-right"></i></span>
                              </button>
                            </li>
                          </template>
                          <template v-else>
                            <li>
                              <button
                                @click="listadoPagina(current_page + 1)"
                                class="btn page-item"
                              >
                                <span><i class="fa fa-arrow-right"></i></span>
                              </button>
                            </li>
                          </template>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </template>
          <template v-else>
            <section id="noticias" class="noticias-internas">
              <div class="seccion-blanca">
                <div class="container">
                  <div class="row noticias-grupo">
                    <div class="col-12 text-center">
                      <h3>{{ mensaje_prev }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </template>
        </template>
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<script>
import SubSectionBanner from '@/views/components/SubSectionBanner';
import SubSectionStandartHead from '@/views/components/SubSectionStandartHead';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import axios from 'axios';
import { config_settings } from '../config.js';

export default {
  components: {
    SubSectionBanner,
    SubSectionStandartHead,
    GoToTrackingModule,
    GuideModule,
  },
  props: ['subSectionData'],
  data() {
    return {
      url_actual: '',
      mensaje_prev: 'loading...',
      detail_open: false,
      main_item: '',
      display: 'redbox',
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: this.subSectionData.cod_sub_section,
      item_list: [],
      crit: 4,
      pages: [],
      final_page: 1,
      current_page: 1,
      detail_item: new Object(),
      load_complete: false,
      lenguage: 1,
      boton_fb: '',
      boton_tw: '',
      boton_ld: '',
      id_news_url: this.$route.params.id,
    };
  },

  methods: {
    obtener_items_paginado() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/news')
        .then((response) => {
          this.crit = 4;
          this.item_list = response.data.news;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.main_item = this.item_list.shift();
        })
        .catch((error) => {
          console.log(error);
          this.mensaje_prev = 'Lo sentimos, no hay noticias para mostrar.';
        });
    },

    listadoPagina(page) {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/news?cReg=' + this.crit + '&&nPag=' + page)
        .then((response) => {
          var arreglo = response.data.news;
          if (arreglo.length == 0) {
            this.listadoPagina(page - 1);
          }

          this.item_list = arreglo;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = page;
          //this.mensaje_error = ""
          //this.mensaje = ""
        })
        .catch((error) => {
          console.log(error.response.data.details);
          toastr.error(error.response.data.details, error.response.data.message, {
            iconClass: 'customer-danger',
          });
          this.mensaje_prev = 'Lo sentimos, no hay noticias para mostrar.';
        });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    openSignedDetail(item, isExternal) {
      this.detail_open = true;
      this.detail_item = item;
      this.scrollToTop();
      this.url_actual = 'comunidad/' + item.id_news;
      if (!isExternal) {
        window.history.pushState(item.id_news, 'Detail', this.url_actual);
      }
    },

    closeSignedDetail() {
      this.detail_open = false;
      this.detail_item = new Object();
      this.scrollToTop();
      this.url_actual = '/comunidad';
      window.history.pushState('List', 'Detail', this.url_actual);
    },

    finditem(id) {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/news/' + id)
        .then((response) => {
          var noticia = response.data;
          this.openSignedDetail(noticia, true);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    validacion_url() {
      if (this.id_news_url != '') {
        this.finditem(this.id_news_url);
      }
    },
  },

  created() {
    this.scrollToTop();
    this.obtener_items_paginado();
    this.validacion_url();
  },
};
</script>

<style>
.comunityPage {
  .contact-inline {
    height: 10px !important;
  }
  .no-border-country {
    border-radius: 2px !important;
  }

  .avatar {
    border-radius: 10px;
  }
  .row-height2 {
    background-color: #e5e5ea;
    border-radius: 15px 15px 15px 15px;
  }

  .not-padding-left {
    padding-left: 0 !important;
    padding-right: 12px !important;
  }
  .not-padding-right {
    padding-right: 0 !important;
    padding-left: 12px !important;
  }
  .posicion-relativa {
    position: relative;
  }
  .btn-3d-celeste {
    color: rgb(43, 172, 234);
    border-color: rgb(43, 172, 234);
    background-color: transparent;
  }
  .btn-3d-celeste:hover,
  .btn-3d-celeste:focus,
  .btn-3d-celeste:active {
    color: rgba(43, 172, 234, 0.7);
  }
  .btn-3d {
    position: relative;
    display: inline-block;
    top: 0;
    margin-bottom: 0;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    border-style: solid;
    border-top-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 6px;
    border-left-width: 1px;
    border-radius: 8px;
    transition: all 0.15s;
  }
  .btn-3d:hover {
    top: 4px;
    margin-bottom: 3px;
    border-bottom-width: 3px;
  }
  .btn-3d:active {
    top: 6px;
    margin-bottom: 5px;
    border-bottom-width: 1px;
  }

  @media (min-width: 0px) {
    .btn-3d-md {
      padding: 12px;
      font-size: 14px;
    }
    .btn-3d-lg {
      padding: 10px 15px;
      font-size: 14px;
    }
    .not-padding-left-fields {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .not-padding-right-fields {
      padding-right: 0px !important;
      padding-left: 0px !important;
    }

    .not-padding-left-fields-peru {
      padding-left: 0 !important;
      padding-right: 0px !important;
    }
    .not-padding-right-fields-peru {
      padding-right: 0 !important;
      padding-left: 0px !important;
    }
  }
  @media (min-width: 576px) {
    .btn-3d-md {
      padding: 12px;
      font-size: 14px;
    }
    .btn-3d-lg {
      padding: 10px 15px;
      font-size: 14px;
    }
    .not-padding-left-fields {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .not-padding-right-fields {
      padding-right: 0px !important;
      padding-left: 0px !important;
    }

    .not-padding-left-fields-peru {
      padding-left: 0 !important;
      padding-right: 10px !important;
    }
    .not-padding-right-fields-peru {
      padding-right: 0 !important;
      padding-left: 0px !important;
    }
  }
  @media (min-width: 768px) {
    .btn-3d-md {
      padding: 12px;
      font-size: 14px;
    }
    .btn-3d-lg {
      padding: 10px 15px;
      font-size: 14px;
    }
    .not-padding-left-fields {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .not-padding-right-fields {
      padding-right: 0px !important;
      padding-left: 0px !important;
    }

    .not-padding-left-fields-peru {
      padding-left: 0 !important;
      padding-right: 12px !important;
    }
    .not-padding-right-fields-peru {
      padding-right: 0 !important;
      padding-left: 12px !important;
    }
  }
  @media (min-width: 992px) {
    .btn-3d-md {
      padding: 10px 15px;
      font-size: 14px;
    }
    .btn-3d-lg {
      padding: 15px 20px;
      font-size: 15px;
    }
    .not-padding-left-fields {
      padding-left: 0 !important;
      padding-right: 12px !important;
    }
    .not-padding-right-fields {
      padding-right: 0 !important;
      padding-left: 12px !important;
    }
  }
  @media (min-width: 1200px) {
    .btn-3d-md {
      padding: 15px;
      font-size: 16px;
    }
    .btn-3d-lg {
      padding: 15px 25px;
      font-size: 16px;
    }
    .not-padding-left-fields {
      padding-left: 0 !important;
      padding-right: 12px !important;
    }
    .not-padding-right-fields {
      padding-right: 0 !important;
      padding-left: 12px !important;
    }
  }
}
</style>
